export default {
  page: 'Page',
  pages: 'Pages',
  verbose_page: 'a page',
  modules: 'Modules',
  general_info: 'General information',

  status: 'Status',
  internal_title: 'Internal title',
  route_name: 'Route name',
  slug: 'Slug',
  meta_title: 'Meta title',
  meta_description: 'Meta Description',
  sections: 'Sections',
};
